/*
  Script for showing a survey to the participants. Uses survey.js for displaying the survey.
*/
import axios from "axios";
import { createApp } from "vue";
import { Model, Serializer } from "survey-core";
import { surveyPlugin as Survey } from "survey-vue3-ui";
import "survey-core/i18n/german";
import DOMPurify from "dompurify";
import { marked } from "marked";

document.addEventListener("DOMContentLoaded", function (event) {
  let surveyContainer = document.querySelector("#survey");
  let surveyId = surveyContainer.getAttribute("data-surveyId");
  let structure = JSON.parse(surveyContainer.getAttribute("data-structure"));
  let locale = surveyContainer.getAttribute("data-locale");
  let accountType = surveyContainer.getAttribute("data-accounttype");
  let preview =
    surveyContainer.getAttribute("data-preview") === "true" ||
    surveyContainer.getAttribute("data-preview") === "yes";

  if (preview) {
    structure.cookieName = null;
  } else {
    structure.cookieName = `pollux-survey-${surveyId}`;
  }

  // Make survey.js aware of some extra properties used for HTML type questions
  Serializer.addProperty("html", "isCollapsible:boolean");
  Serializer.addProperty("html", "boxTitle:string");
  Serializer.addProperty("matrix", "columnLabelsAreVertical:boolean");

  let survey = new Model(structure);

  // Custom themes can be created with the online theme editor: https://surveyjs.io/create-free-survey
  survey.applyTheme({
    cssVariables: {
      "--sjs-primary-backcolor": "#266696",
    },
  });

  survey.onAfterRenderQuestion.add(function (survey, options) {
    let descElems = options.htmlElement.querySelectorAll(
      ".sd-question__description",
    );
    for (let descElem of descElems) {
      const descElemParent = descElem.parentElement;
      if (!descElem.textContent || descElem.textContent.trim() === "") {
        descElemParent.removeChild(descElem);
      }
    }
    if (
      options.question.getType() === "matrix" &&
      options.question.columnLabelsAreVertical
    ) {
      options.htmlElement.classList.add("hasVerticalColumLabels");
    }

    if (
      options.question.getType() === "html" &&
      options.question.isCollapsible
    ) {
      let showInfoButton = document.createElement("button");
      showInfoButton.classList.add("button", "is-primary", "is-fullwidth");
      let iconWrapperElem = document.createElement("span");
      iconWrapperElem.classList.add("icon", "m-r-5");
      let iconElem = document.createElement("i");
      iconElem.classList.add("fa", "fa-chevron-right");
      iconWrapperElem.appendChild(iconElem);
      showInfoButton.appendChild(iconWrapperElem);
      let titleElem = document.createElement("span");
      titleElem.textContent = options.question.boxTitle[locale];
      showInfoButton.appendChild(titleElem);
      let wrapperElem = options.htmlElement.querySelector("div");
      wrapperElem.classList.add(
        "is-hidden",
        "notification",
        "is-info",
        "mt-4",
        "mb-5",
      );
      options.htmlElement.insertBefore(showInfoButton, wrapperElem);

      showInfoButton.addEventListener("click", function (event) {
        event.preventDefault();

        if (wrapperElem.classList.contains("is-hidden")) {
          wrapperElem.classList.remove("is-hidden");
          iconElem.classList.remove("fa-chevron-right");
          iconElem.classList.add("fa-chevron-down");
        } else {
          wrapperElem.classList.add("is-hidden");
          iconElem.classList.remove("fa-chevron-down");
          iconElem.classList.add("fa-chevron-right");
        }
      });
    }
  });
  survey.onCurrentPageChanged.add(function (survey, options) {
    window.scroll(0, 100);
  });
  survey.onComplete.add(function (survey, options) {
    window.scroll(0, 0);
  });
  survey.locale = locale;
  survey.onUpdateQuestionCssClasses.add(function (survey, options) {});

  // Add the marked Markdown converter to handle descriptions etc. in Markdown
  survey.onTextMarkdown.add(function (survey, options) {
    var str = DOMPurify.sanitize(marked.parse(options.text));
    //remove root paragraphs <p></p>
    options.html = str.replace(/^<p>([\s\S]*?)<\/p>$/, "$1");
  });
  survey.setVariable("polluxAccountType", accountType);

  // If preview is `true` answers are not saved to the database.
  if (preview) {
    survey.onComplete.add(function (sender, options) {
      // Nothing to show
      //options.showDataSavingSuccess();
    });
  } else {
    survey.onComplete.add(function (sender, options) {
      let resultsUuid = surveyContainer.getAttribute("data-results-uuid");
      axios
        .post(`/surveys/${surveyId}/results`, {
          results: sender.data,
          resultsUuid,
        })
        .then(function (response) {
          //options.showDataSavingSuccess();
          //Nothing to show.
        })
        .catch(function (error) {
          options.showDataSavingError();
          survey.deleteCookie(survey.cookieName);
        });
    });
  }

  globalThis.__VUE_OPTIONS_API__ = true;
  globalThis.__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ = false;
  globalThis.__VUE_PROD_DEVTOOLS__ = process.env.NODE_ENV !== "production";
  createApp({
    setup() {
      return { survey };
    },
  })
    .use(Survey)
    .mount("#survey");
});
